import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ removePadding?: boolean }>()(
  (theme: Theme, { removePadding }) => ({
    noResultSubHeading: {
      marginTop: theme.spacing(2),
      color: theme.palette.textField.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    resultHeadingContainer: {
      width: theme.spacing(27.875),
      height: theme.spacing(2.5),
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(2),
    },
    resultHeading: {
      color: theme.palette.textField.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    noResultHeaderContainer: {
      paddingBottom: removePadding ? theme.spacing(0) : theme.spacing(5),
      paddingTop: removePadding ? theme.spacing(2) : theme.spacing(0),
      paddingLeft: theme.spacing(2),
    },
    noResultHeading: {
      color: theme.palette.textField.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
  })
)
